import React from 'react';
import { Card, CardContent, Typography, Box, Divider, List, ListItem, ListItemText, Chip } from '@mui/material';

const AnonymousDetail = ({ visitor, activities = [] }) => {
  if (!visitor) return <Typography>Select a visitor to view details</Typography>;

  return (
    <Card sx={{ height: '100%', overflowY: 'auto' }}>
      <CardContent>
        <Typography variant="h5" component="h2" gutterBottom>
          Visitor ID: {visitor._id.slice(-6)}
        </Typography>

        <Box sx={{ my: 2 }}>
          <Chip
            label={visitor.visitorinfo?.country_name || 'Unknown Location'}
            size="small"
            color="primary"
            variant="outlined"
          />
        </Box>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h6" gutterBottom>
          Visitor Info
        </Typography>
        <List dense>
          {Object.entries(visitor.visitorinfo || {}).map(([key, value]) => (
            <ListItem key={key} disablePadding>
              <ListItemText
                primary={<Typography variant="subtitle2" color="primary">{key}</Typography>}
                secondary={String(value || 'N/A')}
              />
            </ListItem>
          ))}
        </List>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h6" gutterBottom>
          Metadata
        </Typography>
        <List dense>
          {Object.entries(visitor.metadata || {}).map(([key, value]) => (
            <ListItem key={key} disablePadding>
              <ListItemText
                primary={<Typography variant="subtitle2" color="primary">{key}</Typography>}
                secondary={String(value || 'N/A')}
              />
            </ListItem>
          ))}
          {(!visitor.metadata || Object.keys(visitor.metadata).length === 0) && (
            <ListItem disablePadding>
              <ListItemText secondary="No metadata available" />
            </ListItem>
          )}
        </List>
      </CardContent>
    </Card>
  );
};

export default AnonymousDetail;
